import { Reducer } from 'redux';
import {
  CreateDepartmentResponse,
  DepartmentResponse,
} from '../.generated/api';

export interface DepartmentState {
  department?: DepartmentResponse | null;
  name: string;
  id: string;
  error?: string;
}

export interface CreateDepartmentActionSuccess {
  type: 'CREATE_DEPARTMENT_SUCCESS';
  department: CreateDepartmentResponse;
}
export interface CreateDepartmentActionFailure {
  type: 'CREATE_DEPARTMENT_FAILURE';
  error: string;
}
export interface GetDepartmentByIdError {
  type: 'GET_DEPARTMENT_ERROR';
  error: string;
}

export interface GetDepartmentByIdSuccess {
  type: 'GET_DEPARTMENT_SUCCESS';
  department: DepartmentResponse;
}

export interface CreateDepartmentResetStateAction {
  type: 'DEPARTMENT_STATE_RESET';
}

export interface CreateDepartmentRemoveErrorAction {
  type: 'DEPARTMENT_REMOVE_ERROR';
}

type CreateDepartmentActionTypes =
  | GetDepartmentByIdError
  | GetDepartmentByIdSuccess
  | CreateDepartmentActionSuccess
  | CreateDepartmentActionFailure
  | CreateDepartmentResetStateAction
  | CreateDepartmentRemoveErrorAction;

const departmentReducer: Reducer<
  DepartmentState,
  CreateDepartmentActionTypes
> = (
  state: DepartmentState | undefined,
  incomingAction: CreateDepartmentActionTypes,
): DepartmentState => {
  if (state === undefined) {
    return { name: '', id: '' };
  }

  switch (incomingAction.type) {
    case 'GET_DEPARTMENT_SUCCESS':
      return {
        name: state.name,
        id: state.id,
        error: undefined,
        department: incomingAction.department,
      };
    case 'GET_DEPARTMENT_ERROR':
      return {
        name: state.name,
        id: state.id,
        error: incomingAction.error,
        department: null,
      };
    case 'CREATE_DEPARTMENT_SUCCESS':
      return {
        name: incomingAction.department.name,
        id: incomingAction.department.id,
        error: undefined,
      };
    case 'CREATE_DEPARTMENT_FAILURE':
      return {
        name: state.name,
        id: state.id,
        error: incomingAction.error,
      };
    case 'DEPARTMENT_STATE_RESET':
      return {
        name: '',
        id: '',
        error: undefined,
        department: null,
      };
    case 'DEPARTMENT_REMOVE_ERROR':
      return { name: state.name, id: state.id, error: undefined };
    default:
      return state;
  }
};

export { departmentReducer };
